import { Unit } from "uom";
/**
 * The unit for binary information ( <code>bit</code> ).
 */
export var Bit = Unit.createBase("Bit", "DataAmount", "bit");
//# sourceMappingURL=data-amount.js.map